/**
 * © Moustapha HENNAWI - Click and Take off - 2021
 */

/*-------------------------------------------------------------------------------------------*/

import { createSlice } from '@reduxjs/toolkit';

/*-------------------------------------------------------------------------------------------*/

const { reducer, actions } = createSlice({
  name: 'reportTrips',
  initialState: {
    items: {}
  },
  reducers: {
    update(state, action) {
      state.items = action.payload;
    },
    delete(state, action) {
      state.items = state.items.filter(
        (item) =>
          !(
            item.deviceId === action.payload.deviceId &&
            item.startTime === action.payload.startTime &&
            item.endTime === action.payload.endTime
          )
      );
    }
  }
});

/*-------------------------------------------------------------------------------------------*/

export { actions as reportTripsActions };
export { reducer as reportTripsReducer };
/*-------------------------------------------------------------------------------------------*/
